import { v7 as uuidv7 } from "uuid"

/** UUID v7 에서 하이픈을 뺀 32자 문자열을 만든다. (서버 Idempotency-Key 규격) */
export const createIdempotencyKey = (): string =>
  uuidv7().replace(/-/g, "")
